import { render } from "./RtxSuccess_pg.vue?vue&type=template&id=24ac020c&scoped=true"
import script from "./RtxSuccess_pg.vue?vue&type=script&lang=js"
export * from "./RtxSuccess_pg.vue?vue&type=script&lang=js"

import "./RtxSuccess_pg.vue?vue&type=style&index=0&id=24ac020c&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ac020c"]])

export default __exports__